import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import GlobalHead from "../shared/head";
import { Col, Container, Row } from "react-bootstrap";
import { SubmitButton } from "../shared/input";
import { FcGoogle } from "react-icons/fc";
import { MdClose, MdFacebook } from "react-icons/md";

const Authentication = (props) => {
	const router = useRouter();

	const { children, title = "SignIn", social = true } = props;

	const Close = () => {
		if (router.query.returnurl) router.push(router.query.returnurl);
		else router.push("/");
	};

	return (
		<>
			<GlobalHead title={`${title} - Mescadesigners`} />
			<div className="auth-layout">
				<div className="close-auth" role="button" onClick={Close}>
					<MdClose className="fs-1 px-2 py-1 text-danger rounded-circle bg-white" />
				</div>
				<div>
					<div className="box">
						{children}
						{social ? (
							<Container>
								<Row className="mt-3 align-items-center">
									<Col className="border border-light" />
									<Col xs="auto font-sm text-grey px-2">You Can Continue With</Col>
									<Col className="border border-light" />
								</Row>
								<Social />
							</Container>
						) : null}
					</div>
				</div>
			</div>
		</>
	);
};

export default Authentication;

const Social = () => (
	<Col sm="10 my-3 mx-auto">
		<Row>
			<Col>
				{/* <Link href="/facebook-login">
          
        </Link> */}
				<SubmitButton
					onClick={(_) => PopLogin(null, "facebook")}
					variant="white border-light rounded-7 border text-dark fw-bold"
					title={
						<>
							<MdFacebook className="me-2 text-primary" /> Facebook
						</>
					}
				/>
			</Col>
			<Col>
				<SubmitButton
					onClick={PopLogin}
					variant="white border-light rounded-7 border text-dark fw-bold"
					title={
						<>
							<FcGoogle className="me-2" /> Google
						</>
					}
				/>
			</Col>
		</Row>
	</Col>
);

const PopLogin = (_, mode = "google") => {
	window.location.href = `https://api-main.dealsonopenbox.com/${mode}-login`;
	return;
	const h = 570,
		w = 520;
	var left = screen.width / 2 - w / 2;
	var top = screen.height / 2 - h / 2;
	var strWindowFeatures = `location=yes,height=570,width=520,left=${left},top=${top},scrollbars=yes,status=yes`;
	var URL = "https://api-main.dealsonopenbox.com/google-login";
	var win = window.open(URL, "_blank", strWindowFeatures);
};
